export default {
    'main-menu.logout.title': 'Logout',
    'loginForm.title': 'Login',
    'loginForm.fields.email.label': 'Email',
    'loginForm.fields.password.label': 'Password',
    'loginForm.buttons.login.title': 'Login',

    'common.phrases.yes': 'Да',
    'common.phrases.no': 'Нет',
    'common.autocomplete.noDataText': 'Ничего не найдено',
    'common.bytes': 'Байт',
    'common.byte': 'Байт',
    'common.kb': 'КБ',
    'common.mb': 'МБ',
    'common.gb': 'ГБ',
    'common.tb': 'ТБ',

    'files.errors.unableToUploadFile': 'Unable to upload file, please try again later'

}